import { SnippetTypeaheadInput } from 'components/Wizards/Wizard/Form/SnippetTypeaheadInput'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'

interface Props {
  schema: FieldSchema
  isLoading?: boolean
  onKeyDown?: (event: React.KeyboardEvent) => void
}

export const TopicField = ({ schema, isLoading, onKeyDown }: Props) => {
  return (
    <SnippetTypeaheadInput
      name="topic"
      schema={schema}
      variant="grey"
      onKeyDown={onKeyDown}
      autoFocus
      typeaheadDisabled
      isLoading={isLoading}
    />
  )
}
